import dynamic from "next/dynamic";
import GlobeHomepageFirstFoldConfig from "./globe-homepage-first-fold-config";
import GlobeHomepageFirstFoldAdvancedConfig from "./globe-homepage-first-fold-advanced-config";
const GlobeHomepageFirstFoldComponent = dynamic(()=>import("./globe-homepage-first-fold-component"));
export default {
    GlobeHomepageFirstFoldComponent,
    GlobeHomepageFirstFoldConfig,
    GlobeHomepageFirstFoldAdvancedConfig
};
